import { TabItem, TabList, Tabs } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import React from 'react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { compensationTabItems } from '../constants';
import RecurringDeductionsView from '../views/RecurringDeductionsView';
import CtcComponent from './CtcComponent';
import { useSearchParams } from 'hooks/useSearchParams';
import PerquisitesView from '../views/PerquisitesView';
import IsFeatureDisabledForRearch from 'access/IsFeatureDisabledForRearch';
import RestrictedRoute from 'components/Routes/RestrictedRoute';

export const CompensationBreakdown = () => {
  const location = useLocation();
  const history = useHistory();
  const currentTab = location.pathname.split('/')[3];
  const { urlParams } = useSearchParams();
  const peopleId = urlParams.get('userId');

  const handleTabChange = (value: string) => {
    const searchParams = peopleId ? `?userId=${peopleId}` : '';
    history.push({
      pathname: `/pay-details/compensation/${value}`,
      search: searchParams,
    });
  };

  return (
    <>
      <Tabs
        variant="bordered"
        orientation="horizontal"
        size={'medium'}
        onChange={handleTabChange}
        defaultValue={compensationTabItems.ctc}
        value={currentTab}>
        <TabList>
          <TabItem value={compensationTabItems.ctc}>CTC Component</TabItem>
          <IsFeatureDisabledForRearch feature={['isRecurringDeductionsDisabled']}>
            <TabItem value={compensationTabItems.deductions}>Deductions</TabItem>
          </IsFeatureDisabledForRearch>
          <IsFeatureDisabledForRearch feature={['isPerquisiteDisabled']}>
            <TabItem value={compensationTabItems.perquisites}>Perquisites</TabItem>
          </IsFeatureDisabledForRearch>
        </TabList>
      </Tabs>

      <Switch>
        <Route path={routePaths.payDetails.compensation.root} exact>
          <Redirect
            to={{
              pathname: routePaths.payDetails.compensation.ctc,
              search: peopleId ? `?userId=${peopleId}` : '',
            }}
          />
        </Route>
        <Route path={routePaths.payDetails.compensation.ctc} component={CtcComponent} exact />
        <RestrictedRoute
          path={routePaths.payDetails.compensation.deductions}
          exact
          component={RecurringDeductionsView}
          disabledFeaturesForRearch={['isRecurringDeductionsDisabled']}
        />
        <RestrictedRoute
          path={routePaths.payDetails.compensation.perquisites}
          exact
          component={PerquisitesView}
          disabledFeaturesForRearch={['isPerquisiteDisabled']}
        />
      </Switch>
    </>
  );
};
